import Card from './card'
import Folder from './folder'
import Icons from './icons'
import Ratting from './ratting'
import Release from './release'
import Favorite from './favorite'
import Watched from './watched'
import Style from './style'
import Menu from './menu'
import Callback from '../../../core/module/callback'
import Plugins from './plugins'
import Subscribe from './subscribe'
import Lgbt from './lgbt'

export default {
    Card,
    Folder,
    Icons,
    Ratting,
    Release,
    Plugins,
    Favorite,
    Watched,
    Lgbt,
    Subscribe,
    Style,
    Menu,
    Callback,
}